import { useTheme } from 'vuetify';
import { useMainStore } from '@/stores/MainStore.js'

let theme;
export default {
  mounted() {
    // set the initial state of the dark mode
    theme = useTheme();
    theme.change(this.isDarkMode ? 'dark' : 'light');
  },
  watch: {
    isDarkMode(newValue) {
      theme.change(newValue ? 'dark' : 'light');
    }
  },
  computed: {
    isDarkMode() {
      const mainStore = useMainStore();
      return mainStore.getDarkMode;
    }
  }
}
